import { createFileRoute } from "@tanstack/react-router";
import { ProductSettingsPage } from "../../../components/products/ProductSettingsPage";
import { requireModuleAccess, MODULE_WORKSPACE } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/workspace/products/$productId/settings")({
  beforeLoad: requireModuleAccess(MODULE_WORKSPACE),
  component: ProductSettingsRoute,
});

function ProductSettingsRoute() {
  const { productId } = Route.useParams();
  return <ProductSettingsPage productId={productId} />;
}
